export function SiteFooter() {
  return (
    <footer className="site-footer" aria-label="网站备案信息">
      <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">
        陇ICP备2026003815号-2
      </a>
      <span className="site-footer-separator" aria-hidden="true">·</span>
      <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=62032102000074"
        rel="noreferrer"
        target="_blank"
      >
        甘公网安备62032102000074号
      </a>
    </footer>
  );
}
